var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "level", staticStyle: { height: "80vh" } },
      [
        _c("div", { staticClass: "level-item" }, [
          _c("i", {
            staticClass: "mdi mdi-spin mdi-loading",
            attrs: { "aria-hidden": "true" },
          }),
          _c("span", [_vm._v("  Preparing new sundry creditor...")]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }